import { forwardRef, RefObject } from 'react';

import styled, { css } from 'styled-components';

import { ITableWrapperProps } from './TableElements.types';

const StyledTableWrapper = styled.div<ITableWrapperProps>`
  ${({ maxWidth, maxHeight, stickyColumns, stickyRows, virtualized }) => css`
    ${maxWidth &&
    css`
      position: relative;
      max-width: ${maxWidth}px;
      overflow-x: auto;
    `}

    ${maxHeight &&
    css`
      position: relative;
      max-height: ${maxHeight}px;
      overflow-y: auto;
    `}

    ${stickyColumns &&
    css`
      position: relative;
      overflow-x: auto;
    `}

    ${stickyRows &&
    css`
      position: relative;
      overflow-y: auto;
    `}

    ${virtualized &&
    css`
      overflow: auto;
    `}
  `}
`;

export const TableWrapper = forwardRef(
  (
    { children, ...rest }: ITableWrapperProps,
    ref: ((instance: HTMLDivElement | null) => void) | RefObject<HTMLDivElement> | null | undefined,
  ) => (
    <StyledTableWrapper ref={ref} {...rest}>
      {children}
    </StyledTableWrapper>
  ),
);
